import script from "./FormArchiveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormArchiveModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__